module.exports = __webpack_public_path__ + "img/top-list-left6.af4df7c6.png";